export default __webpack_public_path__ + "static/media/UserGuide_tr_TR.16d6b4d7.pdf";